define('modules/shell/widgets/datepicker/i18n/he',{
    "datepicker":{
        "clear":"נקה"
    }
});

